import { Logo, MultiContainer } from '@shared/ui'
import styles from './Footer.module.scss'
import { Copyright } from '../copyright/Copyright'
import { SocialBar } from '@features/socialBar'
import waveFooter from '@shared/assets/images/waveFooter.svg'
import waveFooterSmall from '@shared/assets/images/waveFooterSmall.svg'
import { TopContent } from '../topContent/TopContent'
import kit from '@shared/assets/images/kit.png'
import { Navbar } from '../navbar/Navbar'
import { useMediaQuery } from '@shared/hooks/useMediaQuery'

export const Footer = () => {
  const isMobile = useMediaQuery('(max-width: 713px)')
  return (
    <>
      <footer>
        <TopContent/>
        <div className={styles.wave}>
          <img src={isMobile ? waveFooterSmall : waveFooter} alt='wave' />
        </div>
        <MultiContainer>
          <nav className={styles.navbar}>
            <Logo variant='footer'/>
            <div className={styles.navbarContent}>
              <Navbar/>
              <SocialBar/>
            </div>
          </nav>
        </MultiContainer>
        <div className={styles.kit}>
          <img src={kit} alt='kit' />
        </div>
      </footer>
      <Copyright/>
    </>
  )
}
